
import { getFutureLayerAppUrlWithReturnTo } from "@/futurelayer/app/app";
import { singularityStore } from "@/store/store";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import NiceButton from "../UI/NiceButton.vue";
import IconButton from "../UI/IconButton.vue";

@Component({
  components: {
    NiceButton,
    IconButton
  }
})
export default class PlanExpiredModal extends Vue {
  get isOpen() {
    return singularityStore.isPlanExpiredModalOpen;
  }

  set isOpen(value: boolean) {
    singularityStore.setPlanExpiredModalOpen(value);
  }

  closeModal() {
    singularityStore.setPlanExpiredModalOpen(false);
  }

  handleAction() {
    window.location.href = getFutureLayerAppUrlWithReturnTo("/");
  }
}
